import React from 'react';
export const ImpressumPage: React.FC = () => {
  return <div className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-346">
      <div className="max-w-4xl mx-auto" data-id="element-347">
        <h1 className="text-4xl text-orange-500 font-light mb-12" data-id="element-348">Impressum</h1>

        <div className="space-y-8 text-gray-700" data-id="element-349">
          {/* Kontaktinformationen */}
          <div data-id="element-350">
            <p className="mb-1" data-id="element-351">Wandelwert</p>
            <p className="mb-1" data-id="element-352">Eva Sophie Schifferer</p>
            <p className="mb-6" data-id="element-353">Inhaberin</p>

            <p className="mb-1" data-id="element-354">Rohrbachstraße 35</p>
            <p className="mb-6" data-id="element-355">60389 Frankfurt am Main</p>

            <p className="mb-1" data-id="element-356">Telefon: +49 (171) 80 80 455</p>
            <p data-id="element-357">
              Email:{' '}
              <a href="mailto:schifferer@wandelwert.com" className="text-orange-500 hover:underline" data-id="element-358">
                schifferer@wandelwert.com
              </a>
            </p>
          </div>

          {/* Steuernummer */}
          <div data-id="element-359">
            <p className="mb-1" data-id="element-360">Steuernummer:</p>
            <p data-id="element-361">013 865 06835</p>
          </div>

          {/* Bildrechte */}
          <div data-id="element-362">
            <p className="mb-1" data-id="element-363">Bildrechte:</p>
            <p data-id="element-364">
              Foto Startseite sowie Portraitfotos:{' '}
              <a href="#" className="text-orange-500 hover:underline" data-id="element-365">
                Markus Püttmann
              </a>
            </p>
          </div>

          {/* Shutterstock */}
          <div data-id="element-366">
            <p className="mb-2" data-id="element-367">
              Diese Seite verwendet stellenweise Bildermaterial der Firma:
            </p>
            <p className="mb-1" data-id="element-368">Shutterstock, Inc.</p>
            <p className="mb-1" data-id="element-369">Empire State Building</p>
            <p className="mb-1" data-id="element-370">350 Fifth Avenue, 21st Floor</p>
            <p data-id="element-371">New York, NY 10118 USA</p>
          </div>

          {/* Disclaimer */}
          <div className="pt-8" data-id="element-372">
            <h2 className="text-3xl text-orange-500 font-light mb-8" data-id="element-373">
              Disclaimer – rechtliche Hinweise
            </h2>

            <div className="space-y-6" data-id="element-374">
              {/* § 1 */}
              <div data-id="element-375">
                <h3 className="font-semibold mb-3" data-id="element-376">
                  § 1 Warnhinweis zu Inhalten
                </h3>
                <p className="leading-relaxed" data-id="element-377">
                  Die kostenlosen und frei zugänglichen Inhalte dieser Webseite
                  wurden mit größtmöglicher Sorgfalt erstellt. Der Anbieter
                  dieser Webseite übernimmt jedoch keine Gewähr für die
                  Richtigkeit und Aktualität der bereitgestellten kostenlosen
                  und frei zugänglichen journalistischen Ratgeber und
                  Nachrichten. Namentlich gekennzeichnete Beiträge geben die
                  Meinung des jeweiligen Autors und nicht immer die Meinung des
                  Anbieters wieder. Allein durch den Aufruf der kostenlosen und
                  frei zugänglichen Inhalte kommt keinerlei Vertragsverhältnis
                  zwischen dem Nutzer und dem Anbieter zustande, insoweit fehlt
                  es am Rechtsbindungswillen des Anbieters.
                </p>
              </div>

              {/* § 2 */}
              <div data-id="element-378">
                <h3 className="font-semibold mb-3" data-id="element-379">§ 2 Externe Links</h3>
                <p className="leading-relaxed" data-id="element-380">
                  Diese Website enthält Verknüpfungen zu Websites Dritter
                  („externe Links"). Diese Websites unterliegen der Haftung der
                  jeweiligen Betreiber. Der Anbieter hat bei der erstmaligen
                  Verknüpfung der externen Links die fremden Inhalte daraufhin
                  überprüft, ob etwaige Rechtsverstöße ersichtlich. Zu dem
                  Zeitpunkt waren keine Rechtsverstöße ersichtlich. Der Anbieter
                  hat keinerlei Einfluss auf die aktuelle und zukünftige
                  Gestaltung und auf die Inhalte der verknüpften Seiten. Das
                  Setzen von externen Links bedeutet nicht, dass sich der
                  Anbieter die hinter dem Verweis oder Link liegenden Inhalte zu
                  Eigen macht. Eine ständige Kontrolle der externen Links ist
                  für den Anbieter ohne konkrete Hinweise auf Rechtsverstöße
                  nicht zumutbar. Bei Kenntnis von Rechtsverstößen werden jedoch
                  derartige externe Links unverzüglich gelöscht.
                </p>
              </div>

              {/* § 3 */}
              <div data-id="element-381">
                <h3 className="font-semibold mb-3" data-id="element-382">
                  § 3 Urheber- und Leistungsschutzrechte
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-383">
                  Die auf dieser Website veröffentlichten Inhalte unterliegen
                  dem deutschen Urheber- und Leistungsschutzrecht. Jede vom
                  deutschen Urheber- und Leistungsschutzrecht nicht zugelassene
                  Verwertung bedarf der vorherigen schriftlichen Zustimmung des
                  Anbieters oder jeweiligen Rechteinhabers. Dies gilt
                  insbesondere für Vervielfältigung, Bearbeitung, Übersetzung,
                  Einspeicherung, Verarbeitung bzw. Wiedergabe von Inhalten in
                  Datenbanken oder anderen elektronischen Medien und Systemen.
                  Inhalte und Rechte Dritter sind dabei als solche
                  gekennzeichnet. Die unerlaubte Vervielfältigung oder
                  Weitergabe einzelner Inhalte oder kompletter Seiten ist nicht
                  gestattet und strafbar. Lediglich die Herstellung von Kopien
                  und Downloads für den persönlichen, privaten und nicht
                  kommerziellen Gebrauch ist erlaubt.
                </p>
                <p className="leading-relaxed" data-id="element-384">
                  Die Darstellung dieser Website in fremden Frames ist nur mit
                  schriftlicher Erlaubnis zulässig.
                </p>
              </div>

              {/* § 4 */}
              <div data-id="element-385">
                <h3 className="font-semibold mb-3" data-id="element-386">
                  § 4 Besondere Nutzungsbedingungen
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-387">
                  Soweit besondere Bedingungen für einzelne Nutzungen dieser
                  Website von den vorgenannten Paragraphen abweichen, wird an
                  entsprechender Stelle ausdrücklich darauf hingewiesen. In
                  diesem Falle gelten im jeweiligen Einzelfall die besonderen
                  Nutzungsbedingungen.
                </p>
                <p className="text-sm" data-id="element-388">
                  Quelle:{' '}
                  <a href="https://www.juraforum.de" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:underline" data-id="element-389">
                    Impressum Muster von JuraForum.de
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};